import {
  ProductCategorie,
  ProductType,
  type Commerce,
} from '@analytics/models';
import { analyticsRoundNumericValue } from '@analytics/utils';
import type { StoreProductData } from '@legacy/common-ui-models';

export function mapProductToCommerce(product: StoreProductData): Commerce {
  // Currently only service and maintenance contracts are supported
  if (product.suiteCrmId !== 'SenO') {
    throw new Error('product type is not supported');
  }

  return {
    productNaam: product.content.title,
    productID: product.suiteCrmId,
    productType: ProductType.Service,
    productCategorie: ProductCategorie.Cvketel_Onderhoud,
    productAantal: '1',
    prijs: analyticsRoundNumericValue(product.price),
  };
}
